// Book Now Buttons - GA4 Events
var GA4_VIEW_ITEM_CLASSTAG = 'cta-button';

// If GA4 metadata variable has values, assume booking page
// If booking page, trigger View Item event
push_view_item_event();

// Add click event for "add to cart" buttons
var elements = document.getElementsByClassName(GA4_VIEW_ITEM_CLASSTAG);
// go through each element, if it contains the text "Book Now" (case insensitive) add the event listener
// additionally we need to filter out any element that doesn't also have the class "button-primary" or "button-tertiary"
for (var i = 0; i < elements.length; i++) {
  if (
    elements[i].innerText.toLowerCase().includes('book now') &&
    (elements[i].classList.contains('button--primary') ||
      elements[i].classList.contains('button--tertiary'))
  ) {
    elements[i].addEventListener('click', push_add_to_cart_event);
  }
}

function push_add_to_cart_event() {
  // post metadata for GA4 Event
  if (!federalGroup_GA4_meta) return false;

  // Get Room Data
  let item_id = federalGroup_GA4_meta.itemId;
  let item_name = federalGroup_GA4_meta.itemName;
  let price = federalGroup_GA4_meta.price;
  if (price) {
    price = parseFloat(price).toFixed(2);
  }

  if (!item_id || !item_name || !price || price <= 0) return false;

  const eventData = {
    currency: 'AUD',
    value: price,
    items: [
      {
        item_id,
        item_name,
        quantity: 1,
        price,
      },
    ],
  };

  // Also Push Add to Cart Event
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'add_to_cart',
    ...eventData,
  });
}

function push_view_item_event() {
  // post metadata for GA4 Event
  if (!federalGroup_GA4_meta) return false;

  // Get Room Data
  let item_id = federalGroup_GA4_meta.itemId;
  let item_name = federalGroup_GA4_meta.itemName;

  let price = federalGroup_GA4_meta.price;
  if (price) {
    price = parseFloat(price).toFixed(2);
  }

  // Only send view item events on single room pages
  if (!item_id || !item_name || !price || price <= 0) return false;

  const eventData = {
    currency: 'AUD',
    value: price,
    items: [
      {
        item_id,
        item_name,
        quantity: 1,
        price,
      },
    ],
  };

  // Also Push Add to Cart Event
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'view_item',
    ...eventData,
  });
}
